import { NoddiAsyncError } from 'noddi-types';
import { FixedBottomBarContainer, NoddiSkeleton } from 'noddi-ui-web';
import { ApiErrorMessageWithTrans } from '../../Error/ApiErrorMessageWithTrans';
import { FlowBackButton } from '../../Layouts/FlowBackButton';
import { BookingStepSkeleton } from './BookingStepSkeleton';
import { NavioContactChatWidget } from './NavioContactChatWidget';

type Props = {
  error?: NoddiAsyncError | null;
  /** Refetches whichever summary queries failed. */
  onRetry: () => void;
  isRetrying: boolean;
};

/** Body a summary step shows while its data settles, so the step chrome stays mounted. */
export const BookingSummaryScreenBody = ({ error, onRetry, isRetrying }: Props) =>
  error ? (
    <ApiErrorMessageWithTrans error={error} isRetrying={isRetrying} onRetry={onRetry} />
  ) : (
    <BookingStepSkeleton rowClassName='h-40' />
  );

/**
 * The summary's bottom bar while its data settles: Back and Chat as on the loaded step, the confirm button as a
 * placeholder. Without a bar the header shows its own Back link instead, and the title jumps once the bar arrives.
 */
export const BookingSummaryLoadingBottomBar = () => (
  <FixedBottomBarContainer>
    <div className='flex items-center gap-2'>
      <FlowBackButton />
      <NavioContactChatWidget />
    </div>
    <NoddiSkeleton variant='button' className='h-9 w-36' />
  </FixedBottomBarContainer>
);
